export default __webpack_public_path__ + "static/media/aid_websites.6b25191b.png";